import { Input } from "controls";
import { MaxLength } from "hooks";
import React, { useRef } from "react";

const InputNOL = ({ handleInpNol, value }) => {
  const inpRef = useRef();

  const handleFocus = () => {
    if (inpRef.current) {
      inpRef.current.select();
    }
  };

  return (
    <Input
      onFocus={handleFocus}
      inputRef={inpRef}
      placeholder="Received"
      variant="outlined"
      size="small"
      onChange={(e) => handleInpNol(e, value)}
      value={value.nol || ""}
      onInput={(e) => (e.target.value = MaxLength(e.target.value, 4))}
      className="shadow-sm"
      sx={{
        maxWidth: "150px",
        "& .MuiInputBase-input": {
          textAlign: "center",
          padding: "6px 10px",
          fontSize: "14px",
        },
      }}
    />
  );
};

export default InputNOL;
